import axios from 'axios';

import { storeType } from '../redux/store';

export const initializeHttpClient = (store: storeType) => {
  axios.defaults.headers['Content-Type'] = 'application/json';

  axios.interceptors.response.use(
    response => response,
    async err => {
      return Promise.reject(err);
    }
  );

  axios.interceptors.request.use(async request => {
    request.headers.languageId = '0';

    if (process.env.NODE_ENV === 'production')
      request.url = request.url?.replace('http://localhost/don/api', BASE_URL);
    return request;
  });
};

const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? '/don/api'
    : 'http://localhost/don/api';
